import * as React from "react";
import { SVGProps } from "react";
const SvgSocialYoutube = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.857 20.714v-9.428L21.022 16l-8.165 4.714Zm18.2-12.279a3.937 3.937 0 0 0-2.778-2.778C25.828 5 15.999 5 15.999 5s-9.827 0-12.278.657A3.936 3.936 0 0 0 .943 8.435C.286 10.886.286 16 .286 16s0 5.114.657 7.565a3.936 3.936 0 0 0 2.778 2.778C6.172 27 16 27 16 27s9.828 0 12.279-.657a3.938 3.938 0 0 0 2.779-2.778c.656-2.451.656-7.565.656-7.565s0-5.114-.656-7.565h-.001Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialYoutube;
